import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/page/searchHome'
import SearchResult from '../page/searchResult'

/*vue router 升级到3.1.x 后，重复点击导航时（连续点击相同路由链接）控制台出现报错 {_name: "NavigationDuplicated", name: "NavigationDuplicated"}，虽然不影响功能使用，但也不能视而不见。*/
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}


Vue.use(Router)

export default new Router({
  mode: 'history', //路由模式，取值为history与hash
  routes: [
    {
      path: '/',
      redirect:'/home'
    },
    {
      path: '/home',
      name: 'home',
      component: Home,
      children:[
        {
          path: '', // 快速查询
          name: '',
          component: () => import('../page/home')
        },
        {
          path: '/zh-cn', // 快速查询
          name: '',
          component: () => import('../page/home')
        },
        {
          path: '/en', // 快速查询
          name: '',
          component: () => import('../page/home')
        },
        {
          path: '/trackingResults', // 快速查询
          name: 'trackingResults',
          component: SearchResult,

        },
        {
          path: 'logisticsList', //
          name: 'logisticsList',
          component: () => import('../page/logisticsList')
        },
        {
          path: '/aboutTrackingYee', //
          name: 'aboutTrackingYee',
          component: () => import('../page/aboutTrackingYee')
        },
        {
          path: '/functionalAdvantages', //
          name: 'functionalAdvantages',
          component: () => import('../page/functionalAdvantages')
        }, {
          path: '/trajectoryTracking', //
          name: 'trajectoryTracking',
          component: () => import('../page/trajectoryTracking')
        }, {
          path: '/trajectoryTracking/zh-cn', //
          name: 'trajectoryTracking',
          component: () => import('../page/trajectoryTracking')
        }, {
          path: '/trajectoryTracking/zh-hk', //
          name: 'trajectoryTracking',
          component: () => import('../page/trajectoryTracking')
        }, {
          path: '/trajectoryTracking/en', //
          name: 'trajectoryTracking',
          component: () => import('../page/trajectoryTracking')
        },
      ]
    },
    {
      path: '/TYiframe', //
      name: 'TYiframe',
      component: () => import('../page/TYiframe')
    },{
      path: '/TYiframe/zh-cn', //
      name: 'TYiframe',
      component: () => import('../page/TYiframe')
    },{
      path: '/TYiframe/zh-hk', //
      name: 'TYiframe',
      component: () => import('../page/TYiframe')
    },{
      path: '/TYiframe/en', //
      name: 'TYiframe',
      component: () => import('../page/TYiframe')
    },{
      path: '/multiTYiframe', //
      name: 'multiTYiframe',
      component: () => import('../page/multiTYiframe')
    },{
      path: '/multiTYiframe/zh-cn', //
      name: 'multiTYiframe',
      component: () => import('../page/multiTYiframe')
    },{
      path: '/multiTYiframe/zh-hk', //
      name: 'multiTYiframe',
      component: () => import('../page/multiTYiframe')
    },{
      path: '/multiTYiframe/en', //
      name: 'multiTYiframe',
      component: () => import('../page/multiTYiframe')
    },
    {
      path:'*',
      redirect:'/home'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js